import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SuiModule } from 'ng2-semantic-ui';

import { TitleService } from './services/title.service';
import { ServerResponseComponent } from './server-response/server-response.component';
import { UserService } from './services/user.service';
import { PaginationComponent } from './pagination/pagination.component';
import { Filter } from './pipes/filter.pipe';
import { TextCopyDirective } from './directives/copy-text.directive';

@NgModule({
  imports: [
    CommonModule,
    SuiModule
  ],
  exports: [
    CommonModule,
    ServerResponseComponent,
    PaginationComponent,
    TextCopyDirective,
    Filter
  ],
  declarations: [
    ServerResponseComponent,
    PaginationComponent,
    TextCopyDirective,
    Filter
  ],
  providers: [
    TitleService,
    UserService,
  ]
})

export class SharedModule {
}
